export default __webpack_public_path__ + "static/picnic-c29198f8ebdecb7a224e96a436bcb3c9.png";